import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button, EmptyState } from '@cyphex/ui';
import { ROUTES } from '@/constants/routes';

/**
 * An address nothing lives at.
 *
 * The catch-all route used to render `<RouteScaffold area="Not found" />`, which
 * said "Not found is not built yet — this route is scaffolded, the owning
 * feature agent will replace it with the real page": a note to a developer,
 * shown to whoever mistyped a link or followed one to a page that has since
 * been removed.
 */
export function NotFound() {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <EmptyState
        tone="neutral"
        icon={Compass}
        title="There is nothing at this address"
        description="The link may be wrong, or the page may have been moved or removed."
        action={
          <Button asChild variant="outline">
            <Link to={ROUTES.chat}>Go to Chat</Link>
          </Button>
        }
      />
    </div>
  );
}
